import React from 'react';

const Button = ({ onClick, disabled, text, aIcon, bIcon, className, type ,style , btnColor}) => {
  return (

    <button
        className={`themeBtn text-center ${className} ${btnColor}`}
        onClick={onClick}
        
        disabled={disabled}
        type={type}
      >
        {bIcon ?
        <>
          {bIcon} <span className="">{text}</span>
        </>
        : text}
      </button>
  );
}

export default Button;
